/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EnrollmentListItemWaterfallStrategy = typeof EnrollmentListItemWaterfallStrategy[keyof typeof EnrollmentListItemWaterfallStrategy];


export const EnrollmentListItemWaterfallStrategy = {
  prefer_personal_fallback_professional: 'prefer_personal_fallback_professional',
  prefer_professional_fallback_personal: 'prefer_professional_fallback_personal',
  only_professional: 'only_professional',
  only_personal: 'only_personal',
} as const;
